import { createVNode as a, mergeProps as n } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/IdcardTwoTone.js";
import c from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return a(c, n(t, {
    icon: d
  }), null);
};
o.displayName = "IdcardTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
